import { Typography } from '@material-ui/core';
import React from 'react';
import makePrintStyles from '../hooks/make-print-styles';

const GradeLevelChip = ({ text = '' }) => {
  const printClasses = usePrintStyles();
  return (
    <Typography
      className={printClasses.chip}
      style={{
        padding: '2px 4px',
        backgroundColor: '#99A7B4',
        color: 'white',
        fontSize: 12,
        fontWeight: 450,
        textAlign: 'center',
        borderRadius: 2,
        marginLeft: 10
      }}
    >
      {text}
    </Typography>
  );
};
const usePrintStyles = makePrintStyles({
  chip: {
    padding: '4px 8px !important',
    fontSize: '24px !important'
  }
});
export default GradeLevelChip;
